import React from 'react'

class DhsvBlogShareIcons extends React.Component {
  render() {
    return (
      <ul className="share-icons">
        <li>
          <a href="#">
            <i className="btb bt-share bt-3x" />
          </a>
        </li>
        <li>
          <a href="#">
            <i className="btb bt-bookmark bt-3x" />
          </a>
        </li>
      </ul>
    )
  }
}

export default DhsvBlogShareIcons
